/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

type ErrorLabelProps = {
  fieldErrors: any
  customError: any
  name: string
}

export const ErrorLabel: React.FC<ErrorLabelProps> = ({
  fieldErrors,
  customError,
  name,
}) => {
  // Map-shaped fieldErrors carry real API messages (e.g. "The email has already
  // been taken.") — capitalizing every word mangles them, so only the legacy
  // array shape (static "This Field Is Mandatory" copy) gets Title Case.
  const isArrayShape = Array.isArray(fieldErrors)
  return (
    <div
      tabIndex={-1}
      css={css`
        text-transform: ${isArrayShape ? 'capitalize' : 'none'};
        transition: opacity 0.1s ease-in-out;
        display: ${fieldErrors[name] ||
        (Array.isArray(fieldErrors) && fieldErrors?.includes(name))
          ? 'inline'
          : 'none'};
        font-size: 13px;
        line-height: 16px;
        color: ${colors.ERROR_LIGHT};
      `}
    >
      <span>
        {(customError && customError[name]) ||
          // Map-shaped fieldErrors ({ field: message }) — e.g. API field errors
          // (player/family forms) — carry the real per-field message, so show
          // that and never the generic copy. Only the legacy array shape (a list
          // of errored field names, no message) falls back to the static string.
          (Array.isArray(fieldErrors)
            ? 'This Field Is Mandatory'
            : fieldErrors?.[name])}
      </span>
    </div>
  )
}
